<template>
  <section class="portfolio" id="portfolio">
    <h1 class="heading">
      <!-- <span> my </span> -->
      <span style="font-weight: bold"> {{ current }} </span> projects
    </h1>
    <p style="font-size:14px">
      The following projects include my own projects as well as projects taught
      in youtube and udemy courses. You can find information about the sources I
      inspired while doing these in the source code files. Most of the projects
      are not completely finished. I try to improve them from time to time. You
      can find more on my Github profile. I would be happy to answer any of your
      questions.
    </p>
    <div class="button-container">
      <div @click="updateFilter('html-css')" class="btn" ref="html_css">
        html-css
      </div>
      <div @click="updateFilter('javascript')" class="btn">javascript</div>
      <div @click="updateFilter('react')" class="btn">react</div>
      <div @click="updateFilter('vue')" class="btn">vue</div>
      <div @click="updateFilter('react_native')" class="btn">react native</div>
      <div @click="updateFilter('other')" class="btn">other</div>
      <div @click="updateFilter('all')" class="btn">all</div>
    </div>

    <div class="box-container">
      <div
        v-for="(project, index) in filteredProjects"
        :key="index"
        class="box html-css"
      >
        <!-- <img
          :src="project.image"
          alt=""
          :class="{ native: this.current === 'rnative' }"
        /> -->
        <img :src="project.image" alt="" />
        <div class="content">
          <!-- <h3>{{ project.title }}</h3> -->
          <p>{{ project.description }}</p>
          <div class="btnx">
            <a
              :href="project.address"
              class="btn fas fa-external-link-alt"
              target="_blank"
            ></a>
            <a :href="project.code" class="btn fas fa-code" target="_blank"></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import projects from "../composables/Projects";
export default {
  data() {
    return {
      current: "all",
      filteredProjects: [],
    };
  },
  mounted() {
    this.filteredProjects = projects;
  },
  methods: {
    updateFilter(e) {
      this.current = e;
      console.log("current : " + this.current);

      this.filteredProjects = projects.filter((proje) => {
        // return proje.category == this.current;
        return proje.category.includes(this.current);
      });
    },
  },
};
</script>
